module.exports = __webpack_public_path__ + "assets/img/delivery.7cfaf65a.png";